export default __webpack_public_path__ + "static/media/RedLozengeGlow.1e1ad070.png";